import BaseActions from '@/store/base/actions'
import Schema from '@/store/modules/companies/schema'

const module = 'companies'

export default BaseActions({module}, {

}, [Schema])